import {useRef, useState} from 'react'
import {Button} from 'react-bootstrap'

import {PurpleNode} from '../../graphql/types/ventasType'
import html2pdf from 'html2pdf.js'
import {parseId, parsePrice} from '../../helpers'
import {Spinner} from '../Spinner'
import moment from 'moment'
import {ViewConcepts} from './ViewConcepts'
import {COLOR_PRIMARY, COLOR_PRIMARY_SOFT, GRAY_TEXT} from '../../helpers/consts'

export const ViewRecibo = ({venta}: {venta: PurpleNode}) => {
  const divRef = useRef<HTMLDivElement>(null)
  const [loadingDown, setLoadingDown] = useState(false)

  const handleDownload = () => {
    if (!divRef.current) return
    setLoadingDown(true)
    html2pdf()
      .set({
        margin: 2,
        image: {type: 'jpeg'},
        html2canvas: {
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        filename: `Venta-${parseId(venta.id)}.pdf`,
      })
      .from(divRef.current)
      .save()
      .then(() => {
        setLoadingDown(false)
      })
  }
  const legthText = venta.totalSaleInWords.split(' ').length
  const isBigText = legthText >= 12
  const textValueView = isBigText
    ? [
        venta.totalSaleInWords
          .split(' ')
          .slice(0, Math.floor(legthText / 2))
          .join(' '),
        venta.totalSaleInWords
          .split(' ')
          .slice(Math.floor(legthText / 2))
          .join(' '),
      ]
    : [venta.totalSaleInWords]
  return (
    <>
      <div className='p-4' style={{overflowX: 'auto'}}>
        <div
          ref={divRef}
          style={{
            minWidth: '500px',
            padding: '20px',
          }}
        >
          <header
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
            }}
          >
            <div>
              <div style={{position: 'relative'}}>
                <img
                  src='/media/jeisat/logo-print.png'
                  alt='Logo jeisat'
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: '290px',
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    fontSize: '10px',
                    bottom: '0',
                    right: '0%',
                    left: '100px',
                  }}
                >
                  NIT. 900.947.196 - 4 REGIMEN COMUN
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'stretch',
                  fontSize: '11px',
                  marginTop: '4px',
                }}
              >
                <p style={{margin: 0, padding: 0}}>
                  Transversal 1E # 11 - 12 Moscopan Popayán - Cauca
                </p>
                <p style={{margin: 0, padding: 0, marginTop: '-4px'}}>
                  Cel: 312 746 1833 Tel: 833 6804 - E-mail: ingenieriajeisat@gmail.com
                </p>
              </div>
            </div>
            <div>
              <div
                style={{
                  padding: '1em',
                  border: `1px solid ${COLOR_PRIMARY}`,
                  borderRadius: '8px',
                }}
              >
                <h3 style={{fontSize: '1em', textAlign: 'center'}}>RECIBO DE CAJA MENOR</h3>
                <div
                  style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}
                >
                  <span style={{color: '#FF0000', fontSize: '16px'}}>N°</span>
                  <span style={{color: '#FF0000', fontSize: '18px', fontWeight: 'bold'}}>
                    {venta.invoiceId}
                  </span>
                </div>
              </div>
            </div>
          </header>
          <div
            style={{border: `1px solid ${COLOR_PRIMARY}`, borderRadius: '8px', overflow: 'hidden'}}
          >
            <div
              style={{
                position: 'relative',
                display: 'flex',
                borderBottom: `1px solid ${COLOR_PRIMARY}`,
                height: '45px',
              }}
            >
              <div style={{flex: 1, padding: '12px'}}>
                <span style={{top: '0', position: 'absolute', fontWeight: '500'}}>CIUDAD:</span>
                <p
                  style={{
                    margin: 0,
                    padding: 0,
                    marginLeft: '60px',
                    fontSize: '20px',
                    color: GRAY_TEXT,
                  }}
                >
                  POPAYÁN
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 0,
                  flexBasis: '228px',
                  color: 'white',
                  backgroundColor: `${COLOR_PRIMARY_SOFT}`,
                  fontWeight: 'bold',
                }}
              >
                <div style={{backgroundColor: COLOR_PRIMARY, padding: '12px'}}>FECHA</div>
                <div style={{padding: '12px', position: 'relative'}}>
                  DÍA
                  <span
                    style={{
                      position: 'absolute',
                      color: COLOR_PRIMARY,
                      fontSize: '18px',
                      top: '8px',
                      left: '8px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {moment(venta.created).format('DD')}
                  </span>
                </div>
                <div
                  style={{
                    padding: '12px',
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    position: 'relative',
                  }}
                >
                  MES
                  <span
                    style={{
                      position: 'absolute',
                      color: COLOR_PRIMARY,
                      fontSize: '18px',
                      top: '8px',
                      left: '8px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {moment(venta.created).format('MM')}
                  </span>
                </div>
                <div
                  style={{
                    padding: '12px',
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    position: 'relative',
                  }}
                >
                  AÑO
                  <span
                    style={{
                      position: 'absolute',
                      color: COLOR_PRIMARY,
                      fontSize: '18px',
                      top: '8px',
                      left: '8px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {moment(venta.created).format('YY')}
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'relative',
                display: 'flex',
                borderBottom: `1px solid ${COLOR_PRIMARY}`,
                height: '45px',
              }}
            >
              <div style={{flex: 1, padding: '12px', width: '498px'}}>
                <span style={{top: '0', position: 'absolute', fontWeight: '500'}}>PAGADO A:</span>
                <span style={{marginLeft: '100px', fontSize: '20px', color: GRAY_TEXT}}>
                  {venta.user.firstName} {venta.user.lastName}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 0,
                  flexBasis: '228px',
                }}
              >
                <div
                  style={{
                    backgroundColor: `${COLOR_PRIMARY_SOFT}`,
                    textAlign: 'center',
                    paddingTop: '5px',
                    borderLeft: `1px solid ${COLOR_PRIMARY}`,
                    width: '100%',
                  }}
                >
                  <span style={{fontWeight: 'bolder', fontSize: '24px', color: COLOR_PRIMARY}}>
                    {parsePrice(venta.saleTotal)}
                  </span>
                </div>
              </div>
            </div>

            <ViewConcepts data={venta.saleproductthroughSet} client={venta.client.name} />

            <div
              style={{
                position: 'relative',
                display: 'flex',
                borderBottom: `1px solid ${COLOR_PRIMARY}`,
                height: '45px',
              }}
            >
              <div style={{flex: 1, padding: '12px', backgroundColor: `${COLOR_PRIMARY_SOFT}`}}>
                <span style={{top: '0', position: 'absolute', fontWeight: '500'}}>
                  VALOR (En letras)
                </span>
                <span
                  style={{
                    marginLeft: '100px',
                    fontSize: '20px',
                    color: GRAY_TEXT,
                    textTransform: 'uppercase',
                  }}
                >
                  {textValueView[0]}
                </span>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                borderBottom: `1px solid ${COLOR_PRIMARY}`,
                height: '45px',
              }}
            >
              <div style={{flex: 1, padding: '12px', backgroundColor: `${COLOR_PRIMARY_SOFT}`}}>
                <span
                  style={{
                    color: GRAY_TEXT,
                  }}
                >
                  {isBigText && textValueView[1]}
                </span>
              </div>
            </div>

            <div style={{display: 'flex', justifyContent: 'space-between', color: COLOR_PRIMARY}}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  flex: 1,
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    padding: '12px',
                    borderBottom: `1px solid ${COLOR_PRIMARY}`,
                    height: '40px',
                  }}
                >
                  <span style={{position: 'absolute', top: '0', fontWeight: '500'}}>CÓDIGO</span>
                </div>
                <div style={{position: 'relative', padding: '12px', height: '40px'}}>
                  <span style={{position: 'absolute', top: '0', fontWeight: '500'}}>APROBADO</span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flex: 1,
                  borderLeft: `1px solid ${COLOR_PRIMARY}`,
                  padding: '8px',
                  backgroundColor: `${COLOR_PRIMARY_SOFT}`,
                }}
              >
                <div>
                  <span style={{fontWeight: 'bold'}}>FIRMA RECIBIDO</span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <span
                    style={{
                      width: '100%',
                      borderTop: '1px solid ' + COLOR_PRIMARY,
                    }}
                  ></span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '4px',
                      gap: '4px',
                    }}
                  >
                    <div style={{display: 'flex', alignItems: 'center', gap: '3px'}}>
                      <span style={{fontWeight: 'bold'}}>C.C.</span>
                      <span
                        style={{
                          width: '14px',
                          height: '14px',
                          border: `1px solid ${COLOR_PRIMARY}`,
                          display: 'inline-block',
                          backgroundColor: 'white',
                        }}
                      />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '3px'}}>
                      <span style={{fontWeight: 'bold'}}>NIT.</span>
                      <span
                        style={{
                          width: '14px',
                          height: '14px',
                          border: `1px solid ${COLOR_PRIMARY}`,
                          display: 'inline-block',
                          backgroundColor: 'white',
                        }}
                      />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '3px'}}>
                      <span style={{fontWeight: 'bold'}}>No.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-4 w-100 d-flex align-items-center justify-content-end'>
        <Button
          variant='dark'
          className='d-flex align-items-center gap-2'
          onClick={handleDownload}
          disabled={loadingDown}
        >
          {loadingDown ? (
            <Spinner size='12px' color='light' />
          ) : (
            <i className='bi bi-download text-light' />
          )}
          Descargar
        </Button>
      </div>
    </>
  )
}
